import { createReducer, on } from '@ngrx/store';
import { libraryActions } from '../actions/library.actions';
import { CoursePreview } from '../models';

export interface LibraryState {
    loaded: boolean | null;
    loading: boolean | null;
    library: CoursePreview[];
}

export const initialState: LibraryState = {
    loaded: null,
    loading: null,
    library: [],
};

export const libraryReducer = createReducer(
    initialState,
    on(
        libraryActions.getLibrary,
        (state): LibraryState => ({
            ...state,
            loaded: null,
            loading: true,
        }),
    ),
    on(
        libraryActions.getLibrarySuccess,
        (state, payload): LibraryState => ({
            ...state,
            loaded: true,
            loading: false,
            library: payload.courses,
        }),
    ),
    on(
        libraryActions.getLibraryError,
        (state): LibraryState => ({
            ...state,
            loading: false,
            loaded: false,
        }),
    ),
    on(
        libraryActions.clear,
        (): LibraryState => ({
            ...initialState,
        }),
    ),
);
